/*eslint-disable*/
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  adjustWalletBalance,
  getUserDetailInfo,
  getUserLedgerAction,
} from "../../actions/payment";
import { clearUser, getUser, updateUser } from "../../actions/users";
import ClientModal from "../../components/modal/clientModal";
import "./styles.scss";
import FilterListIcon from "@mui/icons-material/FilterList";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { subDays } from "date-fns";
import moment from "moment";
import { DateRangePicker } from "react-date-range";
import { getWalletByLegacyUser } from "../../apis/admin/wallet-apis";
import AdjustBalanceModal from "../../components/modal/AdjustBalanceModal";
import { useStyles } from "../../components/modal/pricingPlanModal/styles";
import Tag from "../../components/Tags";
import useCustomTable from "../../components/table/CustomTable";
import LegacyWalletView from "../../components/wallets/LegacyWalletView";
import UnifiedWalletView from "../../components/wallets/UnifiedWalletView";
import { TAG_COLOR } from "../../constants/const";
import { useCity, useShowToast } from "../../hooks";
import { strings } from "../../I18n";
import E_Bike from "../../images/bikes/bicycle.png";
import Bike from "../../images/bikes/bike.png";
import {
  convertDateFromUtc0ToLocal,
  convertDateToHumanReadableFormat,
  convertDateToUtc0InMilliseconds,
  isSuperAdmin,
  modifyCurrencyToSymbol,
  modifyCurrencyToSymbolAndValue,
  reformatFilter,
  reformatSort,
} from "../../utils/utils";

const UserLedger = (props) => {
  const { id, cityId } = useParams();
  const { selectedCity } = useCity();
  const showToast = useShowToast();
  const [walletData, setWalletData] = useState(null);
  const [walletLoading, setWalletLoading] = useState(true);
  const [walletError, setWalletError] = useState(null);
  const [userDetailInfoLoading, setUserDetailInfoLoading] = useState(false);
  const [adjustModalVisible, setAdjustModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const classes = useStyles();
  const showNewUI =
    isSuperAdmin(props.adminDetails) || props.adminDetails?.newBackendEnabled;
  const [state, setState] = useState([
    {
      startDate: subDays(new Date(), 7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const openAdjustModal = () => {
    setAdjustModalVisible(true);
  };
  const closeAdjustModal = () => {
    setAdjustModalVisible(false);
  };

  const openEditModal = () => {
    setEditModalVisible(true);
  };
  const closeEditModal = () => {
    setEditModalVisible(false);
    props.clearUser();
  };

  useEffect(() => {
    if (props.updateUserSuccess) {
      closeEditModal();
      props.getUser(id);
    }
  }, [props.updateUserSuccess]);

  useEffect(() => {
    return () => {
      props.clearUser();
    };
  }, []);

  const [showFilter, setShowFilter] = useState(false);

  const toggleShowFilter = () => {
    setShowFilter((prevState) => !prevState);
  };

  useEffect(() => {
    setUserDetailInfoLoading(props.userDetailInfoSuccess === undefined);
  }, [props.userDetailInfoSuccess]);

  const fetchWalletData = async () => {
    try {
      setWalletLoading(true);
      setWalletError(null);
      const data = await getWalletByLegacyUser(
        parseInt(id),
        cityId ? parseInt(cityId) : undefined,
        true
      );
      setWalletData(data);
    } catch (err) {
      console.error("Error fetching wallet data:", err);
      setWalletError(err);
    } finally {
      setWalletLoading(false);
    }
  };

  useEffect(() => {
    fetchWalletData();
  }, [id, cityId]);

  const refetchData = () => {
    props.getUser(id);
    if (showNewUI && walletLoading) return;
    props.getUserLedgerAction(
      localPage,
      debouncedSearchTerm,
      selectedCity,
      reformatSort(sortData),
      reformatFilter(filterData),
      localRows,
      id,
      convertDateToUtc0InMilliseconds(state[0].startDate),
      convertDateToUtc0InMilliseconds(state[0].endDate)
    );
    props.getUserDetailInfo(id);
  };

  const formatDateAndTimeForLedger = (date) => {
    const dateObj = new Date(date);
    const dateStr = dateObj.toLocaleDateString("en-US");
    const timeStr = dateObj.toLocaleTimeString("en-US");
    return `${dateStr} ${timeStr}`;
  };

  const columns = useMemo(
    () => [
      {
        name: strings("descriptions.paymentDate"),
        selector: "cityId",
        center: true,
        cell: (row) => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            {formatDateAndTimeForLedger(
              convertDateFromUtc0ToLocal(row.dateCreated)
            )}
          </div>
        ),
      },
      {
        name: strings("descriptions.remarks"),
        selector: "note",
        center: true,
      },
      {
        name: strings("descriptions.particulars"),
        selector: "particulars",
        center: true,
      },

      {
        name: strings("descriptions.debit"),
        selector: "debit",
        center: true,
        cell: (row, index, column, id) => {
          return (
            <>
              {row?.debit === 0 ? (
                "-"
              ) : (
                <Tag text={row?.debit / 100} colorTag={TAG_COLOR.RED} />
              )}
            </>
          );
        },
      },
      {
        name: strings("descriptions.credit"),
        selector: "credit",
        center: true,
        cell: (row, index, column, id) => {
          return (
            <>
              {row?.credit === 0 ? (
                "-"
              ) : (
                <Tag text={row?.credit / 100} colorTag={TAG_COLOR.GREEN} />
              )}
            </>
          );
        },
      },
      {
        name: strings("descriptions.balance"),
        selector: "balance",
        center: true,
        cell: (row, index, column, id) => row?.balance / 100,
      },
    ],
    []
  );

  const reloadData = () => {
    refetchData();
  };
  const addButtonClick = () => {};
  const filterObject = [];

  const {
    renderCustomTable,
    renderHeaderBar,
    localPage,
    localRows,
    sortData,
    debouncedSearchTerm,
    filterData,
    setLoading,
    resetPagination,
  } = useCustomTable(
    columns,
    props.userLedgerList,
    reloadData,
    addButtonClick,
    filterObject,
    strings("descriptions.userLedger")
  );

  const pricingPlan = useCallback(
    (plan) => (
      <>
        <Card elevation={4} className={classes.card}>
          <CardContent>
            <Typography className={classes.planType} variant="body2">
              {plan?.typeDisplayValue}
            </Typography>
            <Typography className={classes.priceTextStyle}>
              {plan?.price}
            </Typography>
            {!!plan?.rules &&
              plan?.rules.map((rule) => {
                return (
                  <Paper elevation={0}>
                    <Grid
                      className={classes.planRuleStyle}
                      container={true}
                      justify="space-between"
                    >
                      <div className={classes.planRuleLableStyle}>
                        {rule?.label?.toUpperCase() === "E-BIKES" ? (
                          <img
                            className={classes.planRuleLableImageStyle}
                            src={E_Bike}
                            height="16px"
                            alt={rule.label}
                          />
                        ) : (
                          <img
                            className={classes.planRuleLableImageStyle}
                            src={Bike}
                            height="26px"
                            alt={rule.label}
                          />
                        )}
                        <span>{rule?.label}</span>
                      </div>
                      <Typography variant="subtitle2" display="inline">
                        {rule?.value}
                      </Typography>
                    </Grid>
                  </Paper>
                );
              })}
            <Typography
              className={classes.descriptionTextStyle}
              variant="caption"
            >
              {plan?.description}
            </Typography>
          </CardContent>
        </Card>
      </>
    ),
    // eslint-disable-next-line
    []
  );

  useEffect(() => {
    refetchData();
  }, [
    localPage,
    debouncedSearchTerm,
    selectedCity,
    sortData,
    filterData,
    localRows,
    id,
    state,
    props.adjustWalletSuccess,
    showNewUI,
    walletLoading,
    walletData?.migratedUser,
  ]);

  const adjustWalletBalanceSave = (data) => {
    const submittingData = {
      userId: id,
      cityId,
      amount: data?.action === "ADD" ? data?.amount * 100 : -data?.amount * 100,
      note: data?.note,
    };
    props.adjustWalletBalance(submittingData);
    closeAdjustModal();
    showToast(strings("descriptions.balanceAdjustSuccess"), "success");

    if (!walletData?.migratedUser) {
      return;
    }

    const originalBalance = walletData?.unifiedWallet?.amountMinor;
    const startTime = Date.now();
    const maxPollDuration = 30000;
    const retryInterval = 2000;

    const pollWalletData = async () => {
      const elapsed = Date.now() - startTime;

      if (elapsed >= maxPollDuration) {
        return;
      }

      try {
        const newData = await getWalletByLegacyUser(
          parseInt(id),
          cityId ? parseInt(cityId) : undefined,
          true
        );
        setWalletData(newData);

        if (newData?.unifiedWallet?.amountMinor !== originalBalance) {
          return;
        }

        setTimeout(pollWalletData, retryInterval);
      } catch (err) {
        console.error("Error polling wallet data:", err);
        setTimeout(pollWalletData, retryInterval);
      }
    };

    setTimeout(pollWalletData, retryInterval);
  };

  if (walletLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "400px",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (walletError) {
    return (
      <Box sx={{ padding: 3 }}>
        <Alert severity="error">
          Error loading wallet data: {walletError.message || "Unknown error"}
        </Alert>
      </Box>
    );
  }

  if (showNewUI) {
    const legacyTransactions = props.userLedgerList;
    const legacyBalance = walletData?.migratedUser
      ? undefined
      : props.userDetailInfo?.balance;
    const userDetailInfoBase = walletData?.migratedUser
      ? {}
      : props.userDetailInfo;
    return (
      <div className="user-ledger-container">
        <div className="data" style={{ marginTop: 25, padding: 15 }}>
          <div className={"header"}>
            <div className={"title"}>
              {strings("descriptions.customerProfile")}
            </div>
          </div>
        </div>
        <UnifiedWalletView
          walletData={walletData}
          userDetailInfo={{
            ...userDetailInfoBase,
            stripeProfileUrl: props.user?.stripeProfileUrl,
            fullName: props.user?.fullName,
            email: props.user?.email,
            userId: props.user?.id,
            emailVerified: props.user?.emailVerified,
            status: props.user?.status,
          }}
          legacyTransactions={legacyTransactions}
          openAdjustModal={openAdjustModal}
          currency={props.userDetailInfo?.balance?.currency}
          onEditClick={openEditModal}
          user={props.user}
          legacyBalance={legacyBalance}
        />
        <AdjustBalanceModal
          onSubmit={adjustWalletBalanceSave}
          addModalVisible={adjustModalVisible}
          handleClose={closeAdjustModal}
          setAddModalVisible={setAdjustModalVisible}
          currency={props.userDetailInfo?.balance?.currency}
        />
        <ClientModal
          visible={editModalVisible}
          closeUserModal={closeEditModal}
          client={props.user}
          updateUser={props.updateUser}
        />
      </div>
    );
  }

  return (
    <div className="user-ledger-container">
      <div className="data" style={{ marginTop: 25, padding: 15 }}>
        <div className={"header"}>
          <div className={"title"}>{strings("descriptions.userLedger")}</div>
          <div className={"refresh"}>
            <div className={"iconButton"}>
              <IconButton aria-label="delete" onClick={reloadData}>
                <RefreshIcon />
              </IconButton>
              <IconButton aria-label="delete" onClick={toggleShowFilter}>
                <FilterListIcon />
              </IconButton>
            </div>
          </div>
        </div>
        {showFilter && (
          <div className="calendar-filter">
            <DateRangePicker
              onChange={(item) => setState([item.selection])}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={state}
              direction="horizontal"
            />
          </div>
        )}

        <LegacyWalletView
          userLedgerList={props.userLedgerList}
          userDetailInfo={props.userDetailInfo}
          userDetailInfoLoading={userDetailInfoLoading}
          state={state}
          renderCustomTable={renderCustomTable}
          openAdjustModal={openAdjustModal}
        />
      </div>
      <AdjustBalanceModal
        onSubmit={adjustWalletBalanceSave}
        addModalVisible={adjustModalVisible}
        handleClose={closeAdjustModal}
        setAddModalVisible={setAdjustModalVisible}
        currency={props.userDetailInfo?.balance?.currency}
      />
    </div>
  );
};

const mapStateToProps = ({
  payment: {
    userLedgerList,
    userLedgerListSuccess,
    userDetailInfo,
    userDetailInfoSuccess,
    adjustWalletSuccess,
  },
  users: { user, updateUserSuccess },
  auth: { adminDetails },
}) => ({
  userLedgerList,
  userLedgerListSuccess,
  userDetailInfo,
  userDetailInfoSuccess,
  adjustWalletSuccess,
  user,
  updateUserSuccess,
  adminDetails,
});

const mapDispatchToProps = {
  getUserLedgerAction,
  getUserDetailInfo,
  adjustWalletBalance,
  getUser,
  updateUser,
  clearUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserLedger);
